import { IHeaderStyles } from 'navigation/header/types';

import { baseHeaderStyles } from './constants.base';

export const headerStyles: IHeaderStyles = {
  ...baseHeaderStyles,
  logoWidth: undefined,
  logoLabel: 'bk_logo_title',
};
